import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useSuperAdmin } from '../../hooks/SuperAdmin/useSuperAdmin'

import AddSuperAdmin from './AddSuperAdmin'

export default function EditSuperAdmin() {
  const { superAdmin, getSuperAdmin } = useSuperAdmin()
  const params = useParams()
  useEffect(() => {
    getSuperAdmin({ superAdminId: params.superAdminId })
  }, [params.superAdminId])

  return <> {superAdmin ? <AddSuperAdmin superAdmin={superAdmin} /> : <Loader />} </>
}
